// CSS Modules - component class name prefix: CountryButton__

<template>
  <div :class="$style.button">
    <span :class="$style.inactive">
      <Flag :flag="flag" size="md" :class="$style.flag" />
      {{ country }}
    </span>
    <span :class="$style.active"
      >Sprache:
      <a
        v-for="(language, index) in languages"
        :key="index"
        :href="language.url"
        :title="language.title"
      >
        <Flag :flag="language.flag" size="xs" :class="$style.flag" />
      </a>
    </span>
  </div>
</template>

<script>
import Flag from "../Flag/Flag";

export default {
  name: "CountryButton",
  components: {
    Flag
  },
  props: {
    languages: {
      type: Array,
      default: () => []
    },
    country: {
      type: String,
      default: ""
    },
    flag: {
      type: String,
      default: ""
    }
  }
};
</script>

<style module lang="scss">
@import "./CountryButton.scss";
</style>
